import { useT } from "@/i18n/I18nProvider";

export function LanguageToggle({ testId = "lang-toggle" }: { testId?: string }) {
  const { locale, otherLocale, switchLocale, t } = useT();
  return (
    <button
      type="button"
      onClick={switchLocale}
      aria-label={t.meta.switchLang}
      data-testid={testId}
      className="font-mono text-[11px] uppercase tracking-eyebrow hover:text-clay transition-colors flex items-center gap-2 group"
    >
      <span aria-current={locale === "en" ? "true" : undefined} className={locale === "en" ? "" : "opacity-50"}>EN</span>
      <span className="opacity-40">/</span>
      <span aria-current={locale === "it" ? "true" : undefined} className={locale === "it" ? "" : "opacity-50"}>IT</span>
      <span className="sr-only">— {t.meta.switchLang} ({otherLocale.toUpperCase()})</span>
    </button>
  );
}
